import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "./store/authStore";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Financeiro } from "./pages/Financeiro";
import { Assinaturas } from "./pages/Assinaturas";
import { Relatorios } from "./pages/Relatorios";
import { Produtividade } from "./pages/Produtividade";
import { MinhaProdutividade } from "./pages/MinhaProdutividade";
import { ContratadoEntregue } from "./pages/ContratadoEntregue";
import { EntregasRealizadas } from "./pages/EntregasRealizadas";
import { AprovacoesTempo } from "./pages/AprovacoesTempo";
import { ProjetosList } from "./pages/projetos/ProjetosList";
import { ProjetoNovo } from "./pages/projetos/ProjetoNovo";
import { ProjetoDetail } from "./pages/projetos/ProjetoDetail";
import { KanbanBoard } from "./pages/projetos/KanbanBoard";
import { TarefasKanban } from "./pages/tarefas/TarefasKanban";
import { CalendarioHub } from "./pages/CalendarioHub";
import { Usuarios } from "./pages/Usuarios";
import { Clientes } from "./pages/Clientes";
import { ClienteDetalhe } from "./pages/clientes/ClienteDetalhe";
import { Perfil } from "./pages/Perfil";
import { Auditoria } from "./pages/Auditoria";
import { ChatPage } from "./pages/chat/ChatPage";
import { Branding } from "./pages/Branding";
import { TiposProjeto } from "./pages/TiposProjeto";
import { TiposTarefa } from "./pages/TiposTarefa";
import { ColunasKanbanAdmin } from "./pages/ColunasKanban";
import { MotivosAjuste } from "./pages/MotivosAjuste";
import { RelatorioAjustes } from "./pages/RelatorioAjustes";
import { Tags } from "./pages/Tags";
import { ProjetoTags } from "./pages/ProjetoTags";
import { Setores } from "./pages/Setores";
import { FuncoesTarefa } from "./pages/FuncoesTarefa";
import { BriefingFormularios } from "./pages/BriefingFormularios";
import { Backups } from "./pages/Backups";
import { TrabalhandoAgora } from "./pages/TrabalhandoAgora";
import { Api } from "./pages/Api";
import { Assinar } from "./pages/Assinar";
import { Verificar } from "./pages/Verificar";
import { useBranding } from "./hooks/useBranding";
import { BackendStatusBanner } from "./components/BackendStatusBanner";
import { InstallPwaBanner } from "./components/InstallPwaBanner";
import { ClienteLayout } from "./pages/cliente/ClienteLayout";
import { ClienteProjetos } from "./pages/cliente/ClienteProjetos";
import { ClienteProjetoDetalhe } from "./pages/cliente/ClienteProjetoDetalhe";

function ProtectedInternalRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // Cliente nunca acessa área interna
  if (user?.perfil === "cliente") return <Navigate to="/cliente" replace />;
  return <>{children}</>;
}

function ProtectedClienteRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // Time interno acessando /cliente vai pra dashboard
  if (user?.perfil !== "cliente") return <Navigate to="/" replace />;
  return <>{children}</>;
}

function App() {
  useBranding();
  return (
    <>
      <BackendStatusBanner />
      <InstallPwaBanner />
      <Routes>
      <Route path="/login" element={<Login />} />

      {/* Públicas — sem auth */}
      <Route path="/assinar/:token" element={<Assinar />} />
      <Route path="/verificar/:codigo" element={<Verificar />} />
      <Route path="/verificar" element={<Verificar />} />

      {/* Portal do cliente */}
      <Route path="/cliente" element={<ProtectedClienteRoute><ClienteLayout /></ProtectedClienteRoute>}>
        <Route index element={<ClienteProjetos />} />
        <Route path="projetos/:id" element={<ClienteProjetoDetalhe />} />
        <Route path="perfil" element={<Perfil />} />
      </Route>

      {/* Área interna */}
      <Route path="/" element={<ProtectedInternalRoute><Layout /></ProtectedInternalRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="projetos" element={<ProjetosList />} />
        <Route path="projetos/novo" element={<ProjetoNovo />} />
        <Route path="projetos/:id/editar" element={<ProjetoNovo />} />
        <Route path="projetos/:id" element={<ProjetoDetail />} />
        <Route path="projetos/:id/kanban" element={<KanbanBoard />} />
        <Route path="tarefas" element={<TarefasKanban />} />
        {/* Cronograma virou aba dentro do Calendário (hub). Redireciona links antigos. */}
        <Route path="cronograma" element={<Navigate to="/calendario?aba=cronograma" replace />} />
        <Route path="calendario" element={<CalendarioHub />} />
        <Route path="financeiro" element={<Financeiro />} />
        <Route path="assinaturas" element={<Assinaturas />} />
        <Route path="relatorios" element={<Relatorios />} />
        <Route path="produtividade" element={<Produtividade />} />
        <Route path="minha-produtividade" element={<MinhaProdutividade />} />
        <Route path="contratado-entregue" element={<ContratadoEntregue />} />
        <Route path="entregas-realizadas" element={<EntregasRealizadas />} />
        <Route path="aprovacoes-tempo" element={<AprovacoesTempo />} />
        <Route path="usuarios" element={<Usuarios />} />
        <Route path="clientes" element={<Clientes />} />
        <Route path="clientes/:id" element={<ClienteDetalhe />} />
        <Route path="auditoria" element={<Auditoria />} />
        <Route path="perfil" element={<Perfil />} />
        <Route path="chat" element={<ChatPage />} />
        <Route path="chat/:conversaId" element={<ChatPage />} />
        <Route path="branding" element={<Branding />} />
        <Route path="admin/tipos-projeto" element={<TiposProjeto />} />
        {/* MELHORIA 8 — "Itens mensais" foi unificado no catálogo de Tipos. */}
        <Route path="admin/itens-mensais" element={<Navigate to="/admin/tipos-tarefa" replace />} />
        <Route path="admin/tipos-tarefa" element={<TiposTarefa />} />
        <Route path="admin/colunas-kanban" element={<ColunasKanbanAdmin />} />
        <Route path="admin/motivos-ajuste" element={<MotivosAjuste />} />
        <Route path="admin/relatorio-ajustes" element={<RelatorioAjustes />} />
        <Route path="admin/tags" element={<Tags />} />
        <Route path="admin/tags-projeto" element={<ProjetoTags />} />
        <Route path="admin/setores" element={<Setores />} />
        <Route path="admin/funcoes-tarefa" element={<FuncoesTarefa />} />
        <Route path="admin/briefings" element={<BriefingFormularios />} />
        <Route path="admin/backups" element={<Backups />} />
        <Route path="admin/agora" element={<TrabalhandoAgora />} />
        <Route path="admin/api" element={<Api />} />
      </Route>
    </Routes>
    </>
  );
}

export default App;
